var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["product-wishlist-add.j2"] = require( "product-wishlist-add.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/quickshop-actions/see-similar-items.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/quickshop-actions/see-similar-items.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
if(t_1.hasOwnProperty("productUrl")) {
var t_5 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_5);
var t_6;
t_6 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"selectedItem") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"selectedItem")),"purchased_quantity") > 0?true:false);
frame.set("isPartiallyOrEntirelyFulfilled", t_6, true);
if(frame.topLevel) {
context.setVariable("isPartiallyOrEntirelyFulfilled", t_6);
}
if(frame.topLevel) {
context.addExport("isPartiallyOrEntirelyFulfilled", t_6);
}
var t_7;
t_7 = (lineno = 3, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-see-similar-items"]));
frame.set("seeMoreText", t_7, true);
if(frame.topLevel) {
context.setVariable("seeMoreText", t_7);
}
if(frame.topLevel) {
context.addExport("seeMoreText", t_7);
}
var t_8;
t_8 = "";
frame.set("disabledClass", t_8, true);
if(frame.topLevel) {
context.setVariable("disabledClass", t_8);
}
if(frame.topLevel) {
context.addExport("disabledClass", t_8);
}
if(runtime.contextOrFrameLookup(context, frame, "isPartiallyOrEntirelyFulfilled") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"source") == "registry" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"skuInfo")),"hasAvailableSku")) {
var t_9;
t_9 = (lineno = 8, colno = 33, runtime.callWrap(t_5, "productUrl", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"productSlug")]));
frame.set("seeMoreLink", t_9, true);
if(frame.topLevel) {
context.setVariable("seeMoreLink", t_9);
}
if(frame.topLevel) {
context.addExport("seeMoreLink", t_9);
}
var t_10;
t_10 = (lineno = 9, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_see_additional_colors_sizes"]));
frame.set("seeMoreText", t_10, true);
if(frame.topLevel) {
context.setVariable("seeMoreText", t_10);
}
if(frame.topLevel) {
context.addExport("seeMoreText", t_10);
}
;
}
else {
if((lineno = 11, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.parentCategory.id",false])) && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryIdToSlug")),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"parentCategory")),"id"))) {
var t_11;
t_11 = (lineno = 13, colno = 34, runtime.callWrap(t_4, "categoryUrl", context, [env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryIdToSlug")),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"parentCategory")),"id")))]));
frame.set("seeMoreLink", t_11, true);
if(frame.topLevel) {
context.setVariable("seeMoreLink", t_11);
}
if(frame.topLevel) {
context.addExport("seeMoreLink", t_11);
}
output += "\n";
;
}
else {
if((lineno = 16, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.parentCategoryId",false])) && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryIdToSlug")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"parentCategoryId"))) {
var t_12;
t_12 = (lineno = 18, colno = 34, runtime.callWrap(t_4, "categoryUrl", context, [env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"categoryIdToSlug")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"parentCategoryId")))]));
frame.set("seeMoreLink", t_12, true);
if(frame.topLevel) {
context.setVariable("seeMoreLink", t_12);
}
if(frame.topLevel) {
context.addExport("seeMoreLink", t_12);
}
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"browseCategory") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"browseCategory") != "wishlist" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"browseCategory") != "registry") {
var t_13;
t_13 = (lineno = 22, colno = 34, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"browseCategory")]));
frame.set("seeMoreLink", t_13, true);
if(frame.topLevel) {
context.setVariable("seeMoreLink", t_13);
}
if(frame.topLevel) {
context.addExport("seeMoreLink", t_13);
}
;
}
else {
var t_14;
t_14 = "";
frame.set("seeMoreLink", t_14, true);
if(frame.topLevel) {
context.setVariable("seeMoreLink", t_14);
}
if(frame.topLevel) {
context.addExport("seeMoreLink", t_14);
}
var t_15;
t_15 = "is-disabled";
frame.set("disabledClass", t_15, true);
if(frame.topLevel) {
context.setVariable("disabledClass", t_15);
}
if(frame.topLevel) {
context.addExport("disabledClass", t_15);
}
;
}
;
}
;
}
;
}
output += "\n\n<li class=\"o-column o-extra-small--6 o-extra-large--5 c-product-add-links__li\">\n\n    <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "seeMoreLink"), env.opts.autoescape);
output += "\" class=\"c-product-add-links__a c-product-see-similar-items__a ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabledClass"), env.opts.autoescape);
output += "\">\n\n        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "seeMoreText"), env.opts.autoescape);
output += "\n\n    </a>\n\n</li>\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"source") == "wishlist" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView")) {
output += "\n\n    ";
output += "\n    ";
env.getTemplate("product-wishlist-add.j2", false, "product/templates/quickshop-actions/see-similar-items.j2", null, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
output += "\n\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/quickshop-actions/see-similar-items.j2"] , dependencies)